<template>
  <div class="scholar-search">
    <!-- 内容 -->
    <div class="content" style="flex: 1">
      <!-- 新建会话 -->
      <div class="infor" v-if="$route.name === 'scholarSearchGuoJiao'">
        <h1 class="title">
          <img width="184" height="44" :src="require('@/assets/images/talent/talent-search-title.png')" alt="">
        </h1>
        <p class="tips">用于分析某位学者画像及成果发表情况</p>
        <div class="search-box" >
          <textareaComp
            style="margin: 0 auto"
            :text-area-width="`900px`"
            :rows-number="3"
            ref="textAreaRef"/>
        </div>

        <!--  推荐问题  -->
        <div class="recommends-list">
          <p
            class="item"
            v-for="(item, index) in recommendData"
            :key="index"
            @click="handleClickRecommend(item)"
          >
            <img v-if="item.type === '1'" width="17" height="15" :src="require('@/assets/images/talent/talent-search-icon.png')" alt="">
            <span>{{ item.question }}</span>
          </p>
        </div>

        <div class="recommends-scholar" v-loading="loading">
          <h3>为您推荐</h3>
          <SearchScholarList
            ref="SearchScholarList"
            :person-list="talentData"
            :city-type="talentLocationValue"
          />
        </div>

<!--        <homeRecommend :startPlay="showMoreContent" />-->
      </div>
      <!-- 专家查询历史会话 -->
      <div v-else class="history-list">
        <historyChat />
      </div>
    </div>
  </div>
</template>

<script>
import { scholarSearchMixin } from '@/mixin/scholarSearch/scholarSearchMixin';
//import scholarIcon from '@/assets/images/home/btn1.svg';
import textareaComp from '@/views/scholarSearch/comps/textareaComp.vue';
import historyChat from '@/views/scholarSearch/comps/historyChat.vue';
import homeRecommend from '@/views/scholarSearch/comps/homeRecommend.vue';
import SearchScholarList from '@/views/scholarSearchGuoJiao/comps/searchScholarList.vue';
import personList from '@/views/requirementAnalysis/comps/personList.vue';

export default {
  computed: {
    personList() {
      return personList
    }
  },
  mixins: [ scholarSearchMixin ],
  name: 'scholarSearchGuoJiao',
  components: {
    //scholarIcon,
    textareaComp,
    historyChat,
    homeRecommend,
    SearchScholarList,
  },
  data () {
    return {}
  },
  created () {
    document.title = '专家查询';
  },
  methods: {},
}
</script>

<style scoped lang="less">
.scholar-search {
  box-sizing: border-box;
  display: flex;
  min-height: 100vh;
  //background-color: #F6F8FD;

  .search-box {
    margin: 40px auto 0;
    width: 80%;
    min-width: 580px;
    max-width: 1080px;
    //padding-top: 20px;
  }

  .content {
    .infor {
      background: url("~@/assets/images/talent/bg-GuoJiao.png") #F6F8FD no-repeat;
      background-size: 100% 500px;
      overflow: hidden;
    }

    .title {
      margin-top: 60px;
      height: 60px;
      font-size: 32px;
      color: #555;
      display: flex;
      align-items: center;
      justify-content: center;
      letter-spacing: 2px;

      span {
        margin-left: 16px;
        color: #FFFFFF;
      }
    }
    p.tips {
      margin-top: 20px;
      font-weight: 500;
      color: #FFFFFF;
      text-align: center;
      font-family: 'PingFang SC', Arial, sans-serif;
      font-size: 18px;
    }
  }

  .history-list {
    /*height: calc(100vh - 280px) ;
    overflow-y: auto;
    box-sizing: border-box;
    padding: 20px 20px 0;*/
  }
}

.recommends-list {
  width: 1100px;
  font-size: 14px;
  color: #666666;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin: 20px auto;

  .item {
    cursor: pointer;
    display: flex;
    align-items: center;
    column-gap: 8px;
    padding: 12px 14px;
    border-radius: 8px;
    border: 1px solid #ffffff;
    backdrop-filter: blur(12px);
    box-shadow: 0 2px 8px #6874ad40;
    background-color: #ffffff;
    margin: 15px 10px;

    &:hover {
      background-color: #f6f8fd;
    }
  }
}

.recommends-scholar {
  width: 1400px;
  margin: 70px auto 40px;

  h3 {
    text-align: center;
    margin-bottom: 30px;
  }
}
</style>
